/**
 * English translations for PaymentQR screen
 */
export const paymentQRTranslations = {
  // Screen
  screen: {
    title: 'Tournament Payment',
  },

  // Progress steps
  progress: {
    payment: 'Payment',
    verification: 'Payment verification',
    game: 'Game',
  },

  // Timer
  timer: {
    label: 'Time left to make the payment',
    expired: 'Expired',
  },

  // Instructions
  instructions: {
    title: 'Send {amount} {currency} to create a tournament',
    titleJoin: 'Send {amount} {currency} to join a tournament',
    description: 'Pay via POLYGON (MATIC) network using QR code or MetaMask',
    subtitle: 'to this Trading Battles deposit address on {network}.',
    awaitingPayment: 'Awaiting payment...',
    dedicatedAddress: 'Deposit address ·',
    copyAddress: 'Copy address',
    addressCopied: 'Copied!',
    revealFull: 'Reveal full',
    hide: 'Hide',
    sendHere: 'SEND HERE',
  },

  // Verify state (DS-2 Payment flow / VerifyScreen)
  verify: {
    title: 'Your payment of {amount} {currency} is being verified',
    subtitleCreate: 'Please wait… your tournament will be created once the payment is complete.',
    subtitleJoin: 'Please wait… you will join the tournament once the payment is complete.',
    transactionOn: 'Verifying transaction on {network}…',
    backToPayment: 'Back to payment',
  },

  // Status messages
  status: {
    confirmed: {
      title: 'Payment confirmed',
      description: 'Your payment has been successfully verified. Publishing tournament...',
      descriptionJoin: 'Your payment has been successfully verified. Joining tournament...',
    },
    failed: {
      title: 'Payment failed',
      description: 'There was a problem with your payment. Please try again or contact support.',
    },
    expired: {
      title: 'Payment expired',
      description: 'The time to make the payment has passed. Create a new payment to continue.',
      descriptionJoin: 'The time to make the payment has passed. Try joining the tournament again.',
    },
    refunded: {
      title: 'Payment refunded',
      description: 'Your payment has been refunded. Contact support if you need assistance.',
    },
    notAllowed: {
      title: 'Join not allowed',
      description: 'You cannot join this tournament. The tournament may be full or already started.',
    },
  },

  // Actions
  actions: {
    cancel: 'Cancel',
    confirmPayment: 'Confirm payment',
    retry: 'Retry payment',
    createNew: 'New payment',
    back: 'Back',
    contact: 'Contact',
  },

  // Errors
  errors: {
    publishFailed: 'Failed to publish tournament: {message}',
    joinFailed: 'Failed to join tournament: {message}',
    loadFailed: 'Failed to load payment data',
    ownershipMismatch: 'This payment belongs to another user',
    networkError: 'Connection error. Please check your internet connection.',
  },

  // Loading
  loading: {
    payment: 'Loading payment...',
    publishing: 'Publishing tournament...',
    joining: 'Joining tournament...',
  },
};

export type PaymentQRTranslations = typeof paymentQRTranslations;
